// extracted by mini-css-extract-plugin
export default {"webcamcapture":"WebcamCapture_webcamcapture__PY4xI","webcam":"WebcamCapture_webcam__ubhS7"};